import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomFormControlAccess } from 'src/app/_core/tools/custom-form-control-access';
import { buildProviders, Coerce } from '@kalidea/kaligraphi';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormValidator } from 'src/app/validators/form-validator';
import { tap } from 'rxjs/operators';
import { isEmpty } from 'src/app/utils/object.utils';

interface DateValidator {
    controlName: string;
    dayProperty: string;
    monthProperty: string;
    errorName: string;
}

const MAX_MONTH_IN_YEAR = 12;
const MAX_DAY_IN_MONTH = 31;

@Component({
    selector: 'app-shared-days-in-month-edit',
    templateUrl: './shared-days-in-month-edit.component.html',
    styleUrls: ['./shared-days-in-month-edit.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(SharedDaysInMonthEditComponent),
    standalone: false
})
export class SharedDaysInMonthEditComponent extends CustomFormControlAccess implements OnInit {

    form: UntypedFormGroup;

    @Coerce('boolean')
    @Input()
    withoutLabel: boolean = false;

    @Coerce('boolean')
    @Input()
    bottomNull: boolean = false;

    constructor(private readonly fb: UntypedFormBuilder) {
        super();
    }

    static isValid(date: { day: number, month: number }) {
        const {day, month} = date || {};
        const daysInMonth = new Date();
        daysInMonth.setMonth(+month || 1);
        daysInMonth.setDate(0);

        if (!day || !month || day > daysInMonth.getDate() || month > 12 || isNaN(day) || isNaN(month)) {
            return {invaliddaysinmonthedit: true};
        }

        return null;
    }

    static validator(control: AbstractControl) {
        const {day, month} = control.value || {};
        return SharedDaysInMonthEditComponent.isValid({day, month});
    }

    writeValue(value: any) {
        this.form.patchValue({
            day: value?.day || null,
            month: value?.month || null
        }, {emitEvent: false});

        super.writeValue(value);
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            day: [null, [FormValidator.number, Validators.max(MAX_DAY_IN_MONTH), FormValidator.int]],
            month: [null, [Validators.max(MAX_MONTH_IN_YEAR), FormValidator.number, FormValidator.int]]
        }, {validators: SharedDaysInMonthEditComponent.validator});

        this.watch$ = this.form.valueChanges.pipe(
            tap(value => this.notifyUpdate(value))
        );
    }

}
